import React from 'react';
import cn from 'classnames';
import type { ChipsProps } from './types';
import './chips.scss';

export const Chips: React.FC<ChipsProps> = ({ children, disabled }) => (
  <div className={cn('chips-default', { disabled })} title={typeof children === 'string' ? children : undefined}>
    {children}
  </div>
);
